export const breakpoints = ['480px', '768px', '1024px', '1280px', '1440px', '1920px', '2560px']

export const settings = {
  breakpoints,
}

export type BreakpoinsTheme = typeof settings
